module.exports = __webpack_public_path__ + "public/img/222222.0acdf9c9.png";